
  import { css } from 'lit';
  export const styles = css`:host{--header-focus-background: var(--ig-expansion-panel-header-focus-background, hsl(from var(--ig-gray-100) h s l/0.3));--ig-theme-variant: dark}`;
  